import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';
import axios, { AxiosRequestConfig } from 'axios';
import { getToken, getUserDetails } from '../../utilities/sessionHelper';

// Define a type for the slice state
interface OBOReportsState {
  data: any;
  error: any;
  loading: boolean;
  oboModal:{
    isModalOpen:boolean,
    selectedOpp:any,
    selectedSOW:any,
    activeTab:string,
  };
  filterData:any;
}

  const initialState: OBOReportsState = {
    data: null,
    error: null,
    loading: false,
    oboModal:{
      isModalOpen:false,
      selectedOpp:{},
      selectedSOW:{},
      activeTab:'',
    },  
    filterData:{}
};

export const fetchOBOReport_AllOpportunities:any = createAsyncThunk(
  'oboReports/fetchOBOReport_AllOpportunities',
  async (params:{
    payload:any
  },{rejectWithValue}) => {
    try {
        const axiosConfig = {
        headers: {
          'Authorization' : 'Bearer '+getToken(),
          'Accept': 'application/json, text/plain, */*',
          'Content-Type': 'application/json',
          // 'loggedInUser': getUserDetails()?.email
        },
        withCredentials: true
      };
      
      const response = await axios.post(`workorder/api/obo/getAllParentOpportunity`,params.payload,axiosConfig);
      if (response.status!==200) {
        const errorData = await response.data.error
        return  rejectWithValue(errorData);
      }
      const userData = await response.data.data;
      return userData;
    } catch (error: any) {
      return rejectWithValue(error?.response?.data?.error || error.message);
    }
  }
);
export const fetchOBOReport_AllSOWs:any = createAsyncThunk(
    'oboReports/fetchOBOReport_AllSOWs',
    async (params:{
      payload:any
    },{rejectWithValue}) => {
      try {
          const axiosConfig = {
          headers: {
            'Authorization' : 'Bearer '+getToken(),
            'Accept': 'application/json, text/plain, */*',
            'Content-Type': 'application/json',
            // 'loggedInUser': getUserDetails()?.email
          },
          withCredentials: true
        };
        
        const response = await axios.post(`workorder/api/obo/getAllSowsForObo`,params.payload,axiosConfig);
        if (response.status!==200) {
          const errorData = await response.data.error
          return  rejectWithValue(errorData);
        }
        const userData = await response.data.data;
        return userData;
      } catch (error: any) {
        return rejectWithValue(error?.response?.data?.error || error.message);
      }
    }
);

export const fetchOBOReport_AllWOs:any = createAsyncThunk(
    'oboReports/fetchOBOReport_AllWOs',
    async (params:{
      payload:any
    },{rejectWithValue}) => {
      try {
          const axiosConfig = {
          headers: {
            'Authorization' : 'Bearer '+getToken(),
            'Accept': 'application/json, text/plain, */*',
            'Content-Type': 'application/json',
            // 'loggedInUser': getUserDetails()?.email
          },
          withCredentials: true
        };
        
        const response = await axios.post(`workorder/api/obo/getAllWorkOrderForObo`,params.payload,axiosConfig);
        if (response.status!==200) {
          const errorData = await response.data.error
          return  rejectWithValue(errorData);
        }
        const userData = await response.data.data;
        return userData;
      } catch (error: any) {
        return rejectWithValue(error?.response?.data?.error || error.message);
      }
    }
);

export const fetchOBOReport_AllChildOpps:any = createAsyncThunk(
    'oboReports/fetchOBOReport_AllChildOpps',
    async (params:{
      payload:any
    },{rejectWithValue}) => {
      try {
          const axiosConfig = {
          headers: {
            'Authorization' : 'Bearer '+getToken(),
            'Accept': 'application/json, text/plain, */*',
            'Content-Type': 'application/json',
            // 'loggedInUser': getUserDetails()?.email
          },
          withCredentials: true
        };
        
        const response = await axios.post(`workorder/api/obo/getAllChildOpportunity`,params.payload,axiosConfig);
        if (response.status!==200) {
          const errorData = await response.data.error
          return  rejectWithValue(errorData);
        }
        const userData = await response.data.data;
        return userData;
      } catch (error: any) {
        return rejectWithValue(error?.response?.data?.error || error.message);
      }
    }
);


export const fetchOBOReport_ChartData:any = createAsyncThunk(
    'oboReports/fetchOBOReport_ChartData',
    async (params:{
      payload:any
    },{rejectWithValue}) => {
      try {
          const axiosConfig = {
          headers: {
            'Authorization' : 'Bearer '+getToken(),
            'Accept': 'application/json, text/plain, */*',
            'Content-Type': 'application/json',
            // 'loggedInUser': getUserDetails()?.email
          },
          withCredentials: true
        };
        
        const response = await axios.post(`workorder/api/obo/getAllGraphData`,params.payload,axiosConfig);
        if (response.status!==200) {
          const errorData = await response.data.error
          return  rejectWithValue(errorData);
        }
        const userData = await response.data.data;
        return userData;
      } catch (error: any) {
        return rejectWithValue(error?.response?.data?.error || error.message);
      }
    }
);

export const getOboDownloadReport:any = createAsyncThunk(
  'oboReports/getOboDownloadFile',
  async (params:{
    payload?: any;
  },{rejectWithValue}) => {
    try {
        const axiosConfig : AxiosRequestConfig<any> = {
        headers: {
          'Authorization' : 'Bearer '+getToken(),
          'Accept': 'application/json, text/plain, */*',
          'Content-Type': 'application/json',
          // 'loggedInUser': getUserDetails()?.email
        },
        withCredentials: true,
        responseType: 'blob',
      };

      const response = await axios.post(`workorder/api/obo/getOboReportForDashboard`,params.payload,axiosConfig);
      if (response.status !== 200) {
        const errorData = await response.data.error
        return  rejectWithValue("Something went wrong. Please try again later.");
      }
      const userData = await response;
      return userData;
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

const _oboReportsSlice:any = createSlice({
  name: 'oboReports',
  initialState,
  reducers: {
    fetchOBOReport_Request: (state) => {
      state.loading = true;
      state.error = null;
    },
    fetchOBOReport_Failure: (state, action: PayloadAction<string>) => {
      state.loading = false;
      state.error = action.payload;
    },
    setoboModalDetails: (state, action: PayloadAction<OBOReportsState['oboModal']>) => {         
      state.oboModal.isModalOpen = action.payload.isModalOpen;
      state.oboModal.selectedSOW = action.payload.selectedSOW;
      state.oboModal.selectedOpp = action.payload.selectedOpp;
      state.oboModal.activeTab = action.payload.activeTab;
    },
    setOBOFilterData: (state, action: PayloadAction<OBOReportsState['filterData']>) => {
      state.filterData = action.payload;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchOBOReport_AllOpportunities.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchOBOReport_AllOpportunities.fulfilled, (state, action) => {
         
        state.data = action.payload?.data;
        state.loading = false;
        state.error = null;
      })
      .addCase(fetchOBOReport_AllOpportunities.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })
      .addCase(getOboDownloadReport.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getOboDownloadReport.fulfilled, (state, action) => {
        state.loading = false;
        state.error = null;
      })
      .addCase(getOboDownloadReport.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })
      .addCase(fetchOBOReport_AllSOWs.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
    .addCase(fetchOBOReport_AllSOWs.fulfilled, (state, action) => {
        state.data = action.payload?.data;
        state.loading = false;
        state.error = null;
    })
    .addCase(fetchOBOReport_AllSOWs.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
    })
    .addCase(fetchOBOReport_AllWOs.pending, (state) => {
        state.loading = true;
        state.error = null;
    })
    .addCase(fetchOBOReport_AllWOs.fulfilled, (state, action) => {
        state.loading = false;
        state.error = null;
    })
    .addCase(fetchOBOReport_AllWOs.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
    })
    .addCase(fetchOBOReport_AllChildOpps.pending, (state) => {
        state.loading = true;
        state.error = null;
    })
    .addCase(fetchOBOReport_AllChildOpps.fulfilled, (state, action) => {
        state.loading = false;
        state.error = null;
    })
    .addCase(fetchOBOReport_AllChildOpps.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
    })
    .addCase(fetchOBOReport_ChartData.pending, (state) => {
        state.loading = true;
        state.error = null;
    })
    .addCase(fetchOBOReport_ChartData.fulfilled, (state, action) => {
        state.loading = false;
        state.error = null;
    })
    .addCase(fetchOBOReport_ChartData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
    })
  }
});

export const {fetchOBOReport_Request, fetchOBOReport_Failure,setoboModalDetails, setOBOFilterData } = _oboReportsSlice.actions;

export default _oboReportsSlice.reducer;